import { render, staticRenderFns } from "./OnlineDoc.vue?vue&type=template&id=7a8329cc&scoped=true&"
import script from "./OnlineDoc.vue?vue&type=script&lang=js&"
export * from "./OnlineDoc.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDoc.vue?vue&type=style&index=0&id=7a8329cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8329cc",
  null
  
)

export default component.exports